<template>
  <div class="main orderSearchDetail" :class="{ mainStatus2: isShowNoneDataShow }">
    <sh-navbar :tab-title="tabTitle" :current-tab-index="currentTabIndex" :scroll-disabled="scrollDisabled" :showNavBar="false">
      <van-search v-model="SearchKey" placeholder="输入商品名称或订单编号搜索" slot="searchBox" shape="round" disabled>
        <template #left>
          <van-icon name="arrow-left" class="turnBackBtn" size="20" @click="$router.go(-1)" />
        </template>
      </van-search>
      <template v-if="dataList.length > 0" :slot="`tab-cnt${currentTabIndex}`">
        <div class="order - list - mian" v-infinite-scroll="loadMore" infinite-scroll-disabled="scrollDisabled" infinite-scroll-immediate-check="false">
          <order-item
            v-for="order in dataList"
            :key="order.PlatformOrderID"
            :item="order"
            @entoDetailPage="entoDetailPage"
            @waitAudit="waitAudit"
            @cancelOrder="cancelOrder"
            @deleteOrder="deleteOrder"
            @continueSubmit="continueSubmit"
            @submitSearch="submitSearch"
            @submitAgain="submitAgain"
            @confirmReceipt="confirmReceipt"
            @checkRebate="checkRebate"
          />
        </div>
      </template>
      <div slot="nav-bottom" v-if="!isShowNoneDataShow">
        <segement-Line v-if="!haveMore && isLoad" line-text="没有更多订单了"> </segement-Line>
        <segement-Line v-else :is-load="true"> </segement-Line>
      </div>
      <div class="noneDataShow" slot="noneDataShow" v-else>
        <div class="content">
          <van-icon name="orders-o" class="icon space" />
          <div class="label">没有相关的订单</div>
          <div class="tip space">可以去看看有哪些想买的</div>
          <van-button type="danger" round class="btn" @click="searchGoods">试试搜索该商品</van-button>
        </div>
      </div>
    </sh-navbar>
    <!-- 领取返利弹窗 -->
    <sh-dialog
      v-if="dialogIsShow"
      :task-id="taskId"
      :product-id="productId"
      :platform-type="platformType"
      :is-logistics-finished="isLogisticsFinished"
      :is-exist-logistics-audit="isExistLogisticsAudit"
      :is-trade-finish="isTradeFinish"
      :is-merchant-pay="isMerchantPay"
      @close="dialogIsShow = false"
    >
    </sh-dialog>
    <!-- 领取返利弹窗错误 -->
    <sh-icon-dialog v-if="receiptDialogShow" :msg="orderErrorMsg" :show-cancel-btn="true" cancel-text="联系客服" confirm-text="我知道了" @cancel="contactCs" @confirm="receiptDialogShow = false">
    </sh-icon-dialog>
  </div>
</template>

<script>
import orderHandler from '@/mixins/orderHandler'
import cancelOrder from '@/mixins/cancelOrder'
import ShNavbar from '@/components/smartComponent/SHnavbar2'
import SegementLine from '@/components/puppetComponent/SegementLine'
import ShDialog from '../order/children/ShDialog'
import ShIconDialog from '@/components/puppetComponent/ShIconDialog'
import { Search, Icon, Button } from 'vant'
import { MessageBox, Indicator, Toast } from 'mint-ui'
import { EvaluateAllInfo } from '@/api/my'

export default {
  mixins: [orderHandler, cancelOrder],
  data() {
    return {
      haveMore: false,
      scrollDisabled: false,
      tabTitle: ['全部', '待完成', '待收货', '已完成'],
      currentTabIndex: 0,
      dataList: [],
      pageScrollTop: 0,
      // 物流是否签收
      isLogisticsFinished: false,
      // 是否出存在‘待审核’信息
      isExistLogisticsAudit: false,
      // 淘宝是否确认收货
      isTradeFinish: false,
      // 商家是否支付
      isMerchantPay: false,
      taskId: '',
      productId: '',
      dialogIsShow: false,
      receiptDialogShow: false,
      orderErrorMsg: '',
      platformType: 0, // 0：淘宝，1：天猫，2：拼多多
      currentPage: 1,
      page: 1,
      pageCount: 1,
      isKeepAlive: false,
      navbarElem: null,
      // 是否触发tabChange方法
      isEmitChange: false,
      SearchKey: '',
      isLoad: false // 是否完成首次加载
    }
  },
  computed: {
    isShowNoneDataShow() {
      return this.isLoad && this.dataList.length <= 0
    }
  },
  components: {
    ShNavbar,
    SegementLine,
    ShDialog,
    ShIconDialog,
    'van-search': Search,
    'van-icon': Icon,
    'van-button': Button
  },
  mounted() {
    this.$nextTick(() => {
      this.navbarElem = document.querySelector('.my-navbar')
      this.navbarElem.addEventListener('scroll', this.handleScroll)
    })
  },
  beforeDestroy() {
    this.navbarElem.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    reFetchPage(from) {
      this.dataList = []
      this.dataList.splice(0)
      this.pageScrollTop = 0
      this.scrollDisabled = false
      this.currentPage = 1
      this.page = 1
      this.pageCount = 1
      this.haveMore = false
      this.isEmitChange = false
      this.isLoad = false
      this.fetchData()
    },
    fetchData() {
      let params = { page: this.currentPage, SearchKey: this.SearchKey }
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      this.scrollDisabled = true
      // 全部
      EvaluateAllInfo(params)
        .then((res) => {
          this.setResData(res)
          this.scrollDisabled = false
          Indicator.close()
          if (!this.isLoad) {
            this.isLoad = true
          }
        })
        .catch((res) => {
          this.haveMore = false
          Indicator.close()
          if (res.ErrMsg) {
            Toast(res.ErrMsg)
          }
        })
    },
    setResData(res) {
      this.dataList = [...this.dataList, ...res.DataList]
      this.page = res.PaginationViewModel.Page
      this.pageCount = res.PaginationViewModel.PageCount
      if (res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount) {
        this.haveMore = false
      }
    },

    // 进入基础销量模式第一步页面
    // goBaseSaleStepOne(itemData) {
    //   let isFreeCard = false;
    //   if (itemData.OrderType) isFreeCard = true;
    //   let toRouteName = "baseStepOne";
    //   let queryData = {
    //     productId: itemData.ProductID,
    //     isFreeCard: isFreeCard,
    //   };
    //   if (itemData.ShopType === 2) {
    //     toRouteName = "pddBaseStepOne";
    //     queryData.taskId = itemData.TaskID;
    //   } else {
    //     queryData.wAPPicUrl = encodeURI(itemData.PicUrl);
    //   }
    //   // 进入购买第一步
    //   this.$router.push({
    //     name: toRouteName,
    //     query: queryData,
    //   });
    // },
    // 联系客服
    contactCs() {
      this.receiptDialogShow = false
      this.$router.push({
        name: 'posterDetail',
        query: {
          isContact: 1
        }
      })
    },
    // 滚动监听
    handleScroll() {
      this.pageScrollTop = this.navbarElem.scrollTop
    },
    loadMore() {
      let { page, pageCount } = this
      if (page >= pageCount) {
        this.haveMore = false
        return
      }
      this.currentPage += 1
      this.haveMore = true
      this.fetchData()
    },
    // 辅助搜索商品按钮【试试搜索该商品】事件
    searchGoods() {
      if (this.SearchKey === '') {
        this.$toast('请先输入商品名称或订单编号搜索')
        return
      }
      this.$router.push({
        name: 'searchResult',
        query: { search: this.SearchKey }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    MessageBox.close()
    this.dialogIsShow = false
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.SearchKey = vm.$route.query.SearchKey
      vm.reFetchPage()
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../order/orderItem.css';
.main .my-navbar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow-y: scroll;
  min-height: 100vh;
}
.orderSearchDetail {
  .noneDataShow {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 450px;
    // background: pink;
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      .label {
        font-size: 16px;
        margin-bottom: 8px;
      }
      .space {
        margin-bottom: 14px;
      }
      .icon {
        font-size: 50px;
        color: #b6b8ba;
      }
      .tip {
        color: #9a9a9a;
        font-size: 14px;
      }
      .btn {
        width: 160px;
        font-size: 14px;
      }
    }
  }
  .turnBackBtn {
    margin-right: 4px;
  }
}
.mainStatus2 {
  background: #fff;
}
</style>
